import { ArrowDown } from "lucide-react";
import { trustItems } from "@/data/resort";
import { useBooking } from "./booking-context";
import { HeroPhoto } from "./OptimizedImage";
import { ResortButton, ResortLink } from "./resort-button";

const titleLines = ["Your Base Camp", "in the Sierra", "Foothills."];

export function Hero() {
  const { openBooking } = useBooking();

  return (
    <section id="top" className="relative min-h-[95svh] bg-forest-deep">
      <div className="hero-bg-enter absolute inset-0 overflow-hidden">
        <HeroPhoto alt="Motorhomes on spacious sites at Auburn RV Resort with golden Sierra foothills at sunset" />
        <div className="overlay-cinematic absolute inset-0" />
      </div>

      <div className="shell relative flex min-h-[95svh] flex-col justify-end pb-26 pt-20 md:pb-32">
        <p
          className="hero-fade-up eyebrow text-primary-foreground/80"
          style={{ animationDelay: "0.2s" }}
        >
          Auburn, California • Sierra Foothills
        </p>

        <h1 className="display-xl mt-6 text-primary-foreground">
          {titleLines.map((line, i) => (
            <span key={line} className="block overflow-hidden">
              <span
                className="hero-line display-xl block"
                style={{ animationDelay: `${0.35 + i * 0.11}s` }}
              >
                {line}
              </span>
            </span>
          ))}
        </h1>

        <p
          className="hero-fade-up mt-8 max-w-2xl text-base leading-relaxed text-primary-foreground/80 md:text-lg"
          style={{ animationDelay: "0.85s" }}
        >
          Spacious full-hookup RV sites, big-rig-friendly accommodations and unforgettable Northern
          California adventures just beyond your doorstep.
        </p>

        <div
          className="hero-fade-up mt-10 flex flex-wrap gap-3"
          style={{ animationDelay: "1.1s" }}
        >
          <ResortButton variant="gold" onClick={openBooking}>
            Check Availability
          </ResortButton>
          <ResortLink variant="onDark" href="#stay">
            Explore the Resort
          </ResortLink>
        </div>
      </div>

      <div className="pointer-events-none absolute bottom-40 right-6 hidden items-center gap-3 text-primary-foreground/70 md:flex md:bottom-44">
        <span className="eyebrow">Scroll</span>
        <span className="hero-scroll-cue">
          <ArrowDown className="size-4" strokeWidth={1.5} />
        </span>
      </div>

      <div className="absolute inset-x-0 bottom-0 z-10 translate-y-1/2">
        <div className="shell">
          <ul className="flex snap-x gap-0 overflow-x-auto rounded-sm border border-border/60 bg-card/95 shadow-soft backdrop-blur-md [scrollbar-width:none] md:overflow-visible">
            {trustItems.map((item) => (
              <li
                key={item}
                className="flex min-w-[46%] snap-start items-center justify-center border-r border-border/60 px-6 py-5 text-center last:border-r-0 sm:min-w-0 sm:flex-1"
              >
                <span className="eyebrow whitespace-nowrap text-foreground/80">{item}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
